export default __webpack_public_path__ + "static/media/car5.7f50aedb.png";